import { useState, useCallback } from 'react';
import { message } from 'antd';
import { owuploadCustomRequest } from '../thunks/file_thunks';
import { getProtectedImageUriGeneric } from '../utils/FileAccessUtils';

interface UseAudioUploadOptions {
	userType: string;
	onSuccess?: (fileUrl: string) => void;
	onError?: () => void;
}

interface UseAudioUploadReturn {
	isUploading: boolean;
	uploadProgress: number;
	uploadAudio: (file: File) => void;
}

const useAudioUpload = (options: UseAudioUploadOptions): UseAudioUploadReturn => {
	const userType = options.userType;
	const onSuccess = options.onSuccess;
	const onError = options.onError;

	const [isUploading, setIsUploading] = useState(false);
	const [uploadProgress, setUploadProgress] = useState(0);

	const uploadAudio = useCallback(
		(file: File) => {
			setIsUploading(true);
			setUploadProgress(0);
			owuploadCustomRequest({
				userType: userType,
				file: file,
				onProgress: (info: { percent: number }) => {
					setUploadProgress(info.percent);
				},
				onSuccess: ({ data }) => {
					if (onSuccess) {
						onSuccess(getProtectedImageUriGeneric(data.fileId, data.fileName));
					}
					setIsUploading(false);
					setUploadProgress(0);
				},
				onError: () => {
					message.error('Failed to upload voice note. Please try again.');
					if (onError) {
						onError();
					}
					setIsUploading(false);
					setUploadProgress(0);
				},
			});
		},
		[userType, onSuccess, onError]
	);

	return {
		isUploading: isUploading,
		uploadProgress: uploadProgress,
		uploadAudio: uploadAudio,
	};
};

export default useAudioUpload;
